import { useValidation } from "hooks/useValidation";
import PropTypes from "prop-types";
import React, { useEffect } from "react";

export function TemplateBuilderIntegerPreview(props) {
    const [isValid, errors, validate] = useValidation();

    useEffect(() => {
        if (!props.disabled) {
            const rule = { fieldName: "answer", maxValue: props.question.maxValue, minValue: props.question.minValue };

            validate([rule], props.answer)
        }
    }, [props.answer, props.disabled]);

    useEffect(() => {
        if (props.answer && !isValid !== props.answer.notValid) {
            props.onChange({
                ...props.answer,
                notValid: !isValid,
                error: errors.answer
            });
        }
    }, [isValid])

    const onChange = (newValue) => {
        if (newValue == null || newValue === '') {
            props.onChange({
                ...props.answer,
                $answerType: "Integer",
                questionId: props.question.id,
                answer: "",
                isAnswered: false,
                error: errors.answer
            });
            return;
        }

        const intValue = newValue.replace(/[^0-9-]/g, '');

        props.onChange({
            ...props.answer,
            $answerType: "Integer",
            questionId: props.question.id,
            answer: +intValue,
            isAnswered: true,
            error: errors.answer
        });
    }


    return <div className="check-preview-form-field">
        <div className="check-preview-input-container">
            <input
                min={props.question.minValue}
                max={props.question.maxValue}
                value={props.answer?.answer ? props.answer.answer : ""}
                onChange={(event) => onChange(event.target.value)}
                type="number"
                step={1}
                disabled={props.disabled}
            ></input>
            {props.deleteComponent}
        </div>
        {props.addAnotherComponent}
    </div>
}

TemplateBuilderIntegerPreview.propTypes = {
    answer: PropTypes.object,
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    addAnotherComponent: PropTypes.node.isRequired,
    deleteComponent: PropTypes.node.isRequired
};